import { useState, useEffect, useRef } from 'react';
import { Grid, Box, Tabs, Tab } from '@mui/material';
import PropTypes from 'prop-types';
import { io } from 'socket.io-client';

// COMPONENTES
import Historial from './historial/Historial';
import Activos from './activos/Activos';

// SERVICES
import { getUnidadesDetenidasActivas, getUnidadesDetenidasHistorial } from '../../services/unidades_detenidas/getDatosUnidadesDetenidas';
import { getCatalogoIncidencias } from '../../services/catalogo_incidencias/getDatosIncidencias';
import { getCoreSysUsers } from '../../services/idle_user_config/getDatosIdleConfig';

// =========================================
// COMPONENTE PERSONALIZADO
// =========================================

const CustomTabPanel = (props) => {

    const { children, value, index, ...other } = props;
    
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );

}

// =========================================
// PROP TYPES
// =========================================

CustomTabPanel.propTypes = {

    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,

};

// =========================================
// PROPS
// =========================================

const a11yProps = (index) => {

    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };

}

// ==========================================================

const UnidadesDetenidas = () => {

    // =========================================
    // FUNCION PARA CONTROLAR TABS
    // =========================================

    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    // =========================================
    // FUNCION PARA CONCENTRAR DATOS
    // =========================================

    const [catalogoIncidencias, setCatalogoIncidencias] = useState([]);
    const [unidadesDetenidasActivas, setUnidadesDetenidasActivas] = useState([]);
    const [unidadesDetenidasHistorial, setUnidadesDetenidasHistorial] = useState([]);
    const [highAlerts, setHighAlerts] = useState([]);

    const getData = async () => {

        const dataUsers = await getCoreSysUsers();
        const usuarioMap = new Map(dataUsers.map(u => [u.value, u.label]));

        const catalogoIncidenciasResponse = await getCatalogoIncidencias();
        const unidadesDetenidasActivasResponse = await getUnidadesDetenidasActivas();
        const unidadesDetenidasHistorialResponse = await getUnidadesDetenidasHistorial();

        const eventsWUser = unidadesDetenidasHistorialResponse.map(event => ({
        ...event,
        usuario_label: usuarioMap.get(event.id_usuario_finalizo) || "Desconocido"
        }));

        // console.log(unidadesDetenidasHistorialResponse);
        setCatalogoIncidencias(catalogoIncidenciasResponse);
        setUnidadesDetenidasActivas(unidadesDetenidasActivasResponse);
        setUnidadesDetenidasHistorial(eventsWUser);

    }

    const refreshActiveData = async () => {

        const data = await getUnidadesDetenidasActivas();
        validarHighAlerts(data);
        setUnidadesDetenidasActivas(data);

    }

    const validarHighAlerts = (data) => {

        const highData = data.filter( alert => 
            (alert.event_type.toLowerCase().includes('panic') && alert.reason_id === 0) ||
            (alert.event_type.toLowerCase().includes('jamm') && alert.reason_id === 0) ||
            (alert.event_type.toLowerCase().includes('gateway') && alert.reason_id === 0)
        );

        if (highData.length > 0) {

            setHighAlerts(highData);

        }

    }

    const socketRef = useRef();

    useEffect(() => {

        getData();

        socketRef.current = io('https://apiuniddet.ebtapps.com');

        socketRef.current.on('connect', () => {
            //console.log('Socket conectado');
        });

        socketRef.current.on('new_stoppage', async () => {

            refreshActiveData();

        });

        socketRef.current.on('connect_error', (err) => {
            //console.error('Error de conexión socket:', err.message);
        });

        return () => {
            socketRef.current.disconnect();
        };

    }, []);

    // =========================================

    return (

        <Grid container>

            <Grid size={6} marginBottom={2}>

                <Tabs value={tabValue} onChange={handleTabChange} aria-label="basic tabs example">
                    <Tab label="Activos"  {...a11yProps(0)}/>
                    <Tab label="Historial"  {...a11yProps(1)}/>
                </Tabs>

            </Grid>

            <Grid size={12}>

                <CustomTabPanel value={tabValue} index={0}>

                    <Activos 
                        eventos={unidadesDetenidasActivas}
                        indicencias={catalogoIncidencias}
                        highAlerts={highAlerts}
                        updateHighAlerts={setHighAlerts}
                        refresh={refreshActiveData}
                    />

                </CustomTabPanel>

                <CustomTabPanel value={tabValue} index={1}>

                    <Historial
                        eventos={unidadesDetenidasHistorial}
                    />

                </CustomTabPanel>

            </Grid>

        </Grid>

    )

}

export default UnidadesDetenidas